import { simpleIconNames as o } from "../data/simple-icon-list.js";
const i = ["simple", "logo"], r = "https://cdn.scalar.com/icons/simple-icons/15.1.0";
function l(s) {
  if (!i.some((n) => s.startsWith(`${n}/`)))
    return !1;
  const [t, e] = s.split("/");
  return o.some((n) => n === e);
}
function m(s) {
  const [t, e] = s.split("/");
  return `${r}/${e}.svg`;
}
function c(s) {
  return `simple/${s}`;
}
const a = {
  name: "simple",
  icons: o.map((s) => c(s)),
  belongsToLibrary: l,
  resolveUrl: m
};
export {
  a as simpleLibrary
};
